import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavigationWrapper from '../../components/NavigationWrapper';
import FooterWrapper from '../../components/FooterWrapper';
import philteamfoto from '../../assets/about/Phil_Teamfoto.webp';

const KIBasierteWissensdatenbanken = () => {
  const [copied, setCopied] = useState(false);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#010003] flex flex-col">
      <NavigationWrapper />
      
      <article className="relative z-10 bg-[#010003] pt-48 pb-24">
        {/* Grid Lines Background */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="w-[1080px] mx-auto h-full relative">
            {/* Horizontal lines */}
            <div className="absolute left-0 right-0 top-[128px] h-px bg-[#16181d]"></div>
            {/* Content starts below this line */}
            <div className="absolute left-0 right-0 bottom-0 h-px bg-[#16181d]"></div>
            
            {/* Vertical grid lines */}
            <div className="absolute left-0 top-[128px] bottom-0 w-px bg-[#16181d]"></div>
            <div className="absolute left-1/3 top-[128px] bottom-0 w-px border-l border-dashed border-[#16181d]"></div>
            <div className="absolute left-2/3 top-[128px] bottom-0 w-px border-l border-dashed border-[#16181d]"></div>
            <div className="absolute right-0 top-[128px] bottom-0 w-px bg-[#16181d]"></div>
          </div>
        </div>

        <div className="w-[1080px] mx-auto relative z-10">
          {/* Back to Blog Link */}
          <div className="flex justify-center w-full">
            <Link 
              to="/blog" 
              className="inline-flex items-center gap-2 text-white/60 text-sm font-geist tracking-[-0.02em] hover:text-white transition-colors mb-12"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Blog
            </Link>
          </div>

          {/* Article Header */}
          <header className="max-w-[720px] mx-auto text-center mb-16">
            <h1 className="text-white text-[42px] font-geist font-normal tracking-[-0.02em] leading-tight mb-8">
              KI-gestützte Wissensdatenbanken: Die Geheimwaffe erfolgreicher Unternehmen im Jahr 2025
            </h1>
            
            {/* Author Info */}
            <div className="flex items-center justify-center gap-3 mb-24">
              <div className="w-6 h-6 rounded-full overflow-hidden">
                <img 
                  src={philteamfoto} 
                  alt="Philipp Fuchs" 
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-white text-sm font-geist tracking-[-0.02em]">Philipp Fuchs</span>
              <span className="text-white/60 text-xs font-geist tracking-[-0.02em]">CEO</span>
            </div>

            {/* Meta Info */}
            <div className="w-full flex items-center justify-between text-white/60 text-sm font-geist tracking-[-0.02em] px-0">
              <div className="flex items-center gap-6">
                <div className="flex items-center gap-2">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5"/>
                    <path d="M8 4V8L10.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                  10 min Lesezeit
                </div>
                <div className="relative overflow-hidden">
                  <button 
                    onClick={() => {
                      navigator.clipboard.writeText(window.location.href);
                      setCopied(true);
                      setTimeout(() => setCopied(false), 2000);
                    }}
                    onMouseLeave={() => setCopied(false)}
                    className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer relative"
                  >
                    <img src="/link.svg" alt="" className="w-3 h-3 flex-shrink-0" />
                    <div className="relative h-5 overflow-hidden w-32">
                      <span className={`block whitespace-nowrap text-left transition-transform duration-300 ${copied ? '-translate-y-full' : 'translate-y-0'}`}>
                        Copy URL
                      </span>
                      <span className={`absolute inset-0 whitespace-nowrap text-left transition-transform duration-300 ${copied ? 'translate-y-0' : 'translate-y-full'}`}>
                        Link kopiert!
                      </span>
                    </div>
                  </button>
                </div>
              </div>
              <span>Okt 03, 2025</span>
            </div>
          </header>

          {/* Article Content */}
          <div className="max-w-[720px] mx-auto text-[#e4e4e7] font-geist tracking-[-0.02em] leading-relaxed">

            <p className="text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed mb-8">
              Entdecken Sie, wie KI-gestützte Wissensdatenbanken das Paradoxon von Informationsüberfluss und Wissensmangel beenden, Mitarbeitern 8-10 Stunden pro Monat sparen und messbare Renditen in allen Abteilungen liefern, indem sie intelligente, kontextbezogene Antworten anstelle von bloßen Suchergebnissen bieten.
            </p>

            <p className="text-xl mb-8">
              Die meisten Unternehmen ertrinken in Informationen und leiden gleichzeitig unter Wissensmangel.
            </p>
            
            <p className="mb-8 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Es ist das klassische Unternehmensparadoxon: Terabytes an Dokumenten, E-Mails, Nachrichten und Besprechungsnotizen... und doch fühlt es sich an, als würde man nach einer Stecknadel im Heuhaufen suchen, wenn jemand eine bestimmte Information benötigt.
            </p>

            <h2 className="text-2xl font-medium text-white mt-12 mb-6">Was genau ist eine KI-gestützte Wissensdatenbank?</h2>
            
            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Lassen Sie uns mit dem Fachjargon aufräumen. Eine KI-gestützte Wissensdatenbank ist nicht nur eine ausgefallene Suchleiste, die auf ein Dokumentenarchiv geklebt wurde.
            </p>

            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Es ist ein intelligentes System, das:
            </p>

            <ul className="list-disc pl-6 mb-8 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li>Sich mit all Ihren Informationsquellen verbindet - Dokumente, E-Mails, Nachrichten (Slack, Teams, etc.), Wikis, Datenbanken, Ticketsysteme, Sie nennen es</li>
              <li>Zusammenhänge und Beziehungen zwischen verschiedenen Informationsstücken versteht</li>
              <li>Antworten liefert, nicht nur Ergebnisse - indem es Informationen synthetisiert, anstatt nur darauf zu verweisen</li>
              <li>Kontinuierlich aus Benutzerinteraktionen und Feedback lernt</li>
              <li>Menschen versteht - Sie können natürliche Fragen stellen und umfassende Antworten erhalten</li>
            </ul>

            <h2 className="text-2xl font-medium text-white mt-12 mb-6">Warum traditionelle Wissensdatenbanken nicht mehr ausreichen</h2>
            
            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Die altmodische Wissensdatenbank stirbt aus, und ehrlich gesagt ist es auch höchste Zeit.
            </p>

            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Hier ist der Grund, warum sie den Anforderungen nicht mehr gerecht werden:
            </p>

            <ul className="list-disc pl-6 mb-8 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li><strong>Niemand nutzt sie.</strong> Herkömmliche Wissensdatenbanken erfordern manuelle Pflege - das Erstellen von Kategorien, das Verschlagworten von Inhalten, das Schreiben von Zusammenfassungen. Das ist ein administrativer Aufwand, für den niemand Zeit hat, also veralten sie schnell.</li>
              <li><strong>Die Suche ist unzureichend.</strong> Suchmaschinen auf Schlüsselwortbasis erfassen weder den Kontext noch die Beziehungen zwischen Dokumenten. Geben Sie "Preisrichtlinie" ein und Sie finden jedes Dokument, das diese Wörter enthält, aber nicht unbedingt die Antwort, die Sie benötigen.</li>
              <li><strong>Informationssilos sind überall.</strong> Das Wissen Ihres Unternehmens befindet sich nicht nur in einem System - es ist über Dutzende von Tools verstreut, und herkömmliche Wissensdatenbanken können diese Lücken nicht effektiv überbrücken.</li>
              <li><strong>Skalierungsprobleme.</strong> Mit zunehmendem Inhalt wird die Navigation komplexer und die Auffindbarkeit nimmt ab. Je größer Ihre herkömmliche Wissensdatenbank wird, desto weniger nützlich ist sie.</li>
            </ul>

            <h2 className="text-2xl font-medium text-white mt-12 mb-6">Die Geschäftsgrundlage: Warum Sie gestern eine KI-Wissensdatenbank gebraucht hätten</h2>
            
            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Die Rendite von KI-Wissensdatenbanken ist nicht theoretisch - sie ist unmittelbar und messbar:
            </p>

            <ul className="list-disc pl-6 mb-8 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li><strong>Zeitersparnis:</strong> Mitarbeiter gewinnen 8-10 Stunden pro Monat zurück, die sie zuvor mit der Suche nach Informationen verbracht haben.</li>
              <li><strong>Wissenssicherung:</strong> Wenn langjährige Mitarbeiter das Unternehmen verlassen, geht ihr institutionelles Wissen nicht mit ihnen.</li>
              <li><strong>Beschleunigtes Onboarding:</strong> Neue Mitarbeiter werden 40% schneller produktiv, wenn sie sofort auf das Erfahrungswissen zugreifen können.</li>
              <li><strong>Reduzierung von Support-Tickets:</strong> Unternehmen berichten von 30-50% weniger internen Support-Tickets, wenn Mitarbeiter sich selbst helfen können.</li>
              <li><strong>Konsistente Kommunikation:</strong> Kundenorientierte Teams liefern präzise, konsistente Informationen an Kunden.</li>
            </ul>

            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Die Einsparungen durch KI-Wissensdatenbanken sind beträchtlich. Hier ein Beispiel für ein mittelständisches Unternehmen:
            </p>

            <div className="bg-[#0f0f14] p-6 rounded-lg mb-8 space-y-3">
              <div className="flex items-center justify-between border-b border-white/5 pb-2">
                <span className="text-white/70">Mitarbeiter</span>
                <span className="font-medium">1.000</span>
              </div>
              <div className="flex items-center justify-between border-b border-white/5 pb-2">
                <span className="text-white/70">Zeitersparnis pro Mitarbeiter/Monat</span>
                <span className="font-medium">8 Stunden</span>
              </div>
              <div className="flex items-center justify-between border-b border-white/5 pb-2">
                <span className="text-white/70">Durchschnittlicher Stundensatz</span>
                <span className="font-medium">25 €/h</span>
              </div>
              <div className="flex items-center justify-between border-b border-white/5 pb-2">
                <span className="text-white/70">Jahresersparnis</span>
                <span className="text-[#00ff9d] font-medium">2,4 Mio. €/Jahr</span>
              </div>
              <div className="pt-2 text-sm text-white/50">
                Berechnung: 1.000 × 8h × 25€ × 12 Monate = 2.400.000 €
              </div>
            </div>

            <p className="mb-12 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Und das berücksichtigt noch nicht einmal die verbesserte Entscheidungsqualität, die reduzierten Schulungskosten und die schnellere Markteinführungszeit.
            </p>

            <h2 className="text-2xl font-medium text-white mt-12 mb-6">Wie verschiedene Abteilungen von KI-Wissensdatenbanken profitieren</h2>
            
            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              KI-Wissensdatenbanken sind keine Einheitslösung - sie bieten spezifischen Nutzen für verschiedene Teams:
            </p>

            <h3 className="text-xl font-medium text-white/70 mt-8 mb-4">Kundensupport</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li>Sofortiger Zugriff auf Produktinformationen, Schritte zur Fehlerbehebung und Richtliniendetails</li>
              <li>70% schnellere Lösungszeiten</li>
              <li>Konsistente Antworten über alle Supportkanäle hinweg</li>
              <li>Schulung neuer Agenten in Tagen statt Wochen</li>
            </ul>

            <h3 className="text-xl font-medium text-white/70 mt-8 mb-4">Vertrieb</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li>Echtzeit-Wettbewerbsinformationen während Gesprächen</li>
              <li>Schneller Zugriff auf Fallstudien und Social Proof</li>
              <li>Präzise Produktdetails und Preisinformationen</li>
              <li>Einarbeitungszeit für neue Mitarbeiter halbiert</li>
            </ul>

            <h3 className="text-xl font-medium text-white/70 mt-8 mb-4">Produkt & Entwicklung</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li>Dokumentation und Architekturentscheidungen auf Knopfdruck</li>
              <li>API-Spezifikationen und Integrationsanleitungen</li>
              <li>Frühere Diskussionen über Funktionen und Roadmap</li>
              <li>Fehlerhistorie und Lösungsansätze</li>
            </ul>

            <h3 className="text-xl font-medium text-white/70 mt-8 mb-4">Personalwesen & Betrieb</h3>
            <ul className="list-disc pl-6 mb-12 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li>Fragen zu Richtlinien sofort beantwortet</li>
              <li>Konsistente Auslegung von Unternehmensrichtlinien</li>
              <li>Einführungsfragen neuer Mitarbeiter ohne manuellen Aufwand</li>
              <li>Prozessdokumentation bei Bedarf verfügbar</li>
            </ul>

            <p className="mb-12 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Das Muster ist klar: Jede Abteilung verbringt zu viel Zeit damit, nach Informationen zu suchen, die bereits vorhanden sind. KI-Wissensdatenbanken beseitigen diese Verschwendung.
            </p>

            <h2 className="text-2xl font-medium text-white mt-12 mb-6">Häufige Einwände (und warum sie nicht stichhaltig sind)</h2>
            
            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Lassen Sie uns die offensichtlichen Bedenken ansprechen:
            </p>

            <h3 className="text-xl font-medium text-white/70 mt-8 mb-4">"Unsere Daten sind zu sensibel für KI"</h3>
            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Moderne KI-Wissensdatenbank-Lösungen bieten Unternehmenssicherheit, einschließlich:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li>Keine Datenspeicherung durch die zugrunde liegenden Modelle</li>
              <li>Private Cloud- oder On-Premise-Bereitstellungsoptionen</li>
              <li>Verschlüsselter Datenspeicher und -übertragung</li>
              <li>Rollenbasierte Zugriffskontrollen</li>
              <li>Prüfprotokollierung und Compliance-Funktionen</li>
            </ul>
            <p className="mb-8 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Im Gegensatz zu Verbraucher-KI-Tools sind Unternehmenslösungen mit Sicherheit als oberster Priorität konzipiert.
            </p>

            <h3 className="text-xl font-medium text-white/70 mt-8 mb-4">"Wir haben keine sauberen, organisierten Daten"</h3>
            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Genau darum geht es. KI-Wissensdatenbanken sind besonders gut darin, Sinn in unstrukturierte Informationen zu bringen. Sie können:
            </p>
            <ul className="list-disc pl-6 mb-8 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li>Relevante Inhalte aus umfangreichen Dokumenten extrahieren</li>
              <li>Zusammenhänge zwischen ungeordneten Dateien verstehen</li>
              <li>Die vertrauenswürdigsten Quellen identifizieren</li>
              <li>Sich durch Nutzung und Feedback kontinuierlich verbessern</li>
            </ul>
            <p className="mb-8 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Je chaotischer Ihre Daten sind, desto mehr Nutzen bietet ein KI-System.
            </p>

            <h3 className="text-xl font-medium text-white/70 mt-8 mb-4">"Unsere Teams werden kein weiteres Tool einführen"</h3>
            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Die besten KI-Wissensdatenbanken integrieren sich dort, wo Ihre Mitarbeiter bereits arbeiten:
            </p>
            <ul className="list-disc pl-6 mb-8 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li>Slack- und Teams-Erweiterungen</li>
              <li>Eigene benutzerdefinierte Benutzeroberfläche</li>
              <li>API-Zugriff für benutzerdefinierte Integrationen</li>
              <li>Mobile Apps für unterwegs</li>
            </ul>
            <p className="mb-8 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Wenn Antworten ohne Kontextwechsel verfügbar sind, erfolgt die Einführung ganz natürlich.
            </p>

            <h3 className="text-xl font-medium text-white/70 mt-8 mb-4">"Es ist nur ein weiterer Techniktrend"</h3>
            <p className="mb-12 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Wissensmanagement ist nichts Neues - Unternehmen kämpfen damit seit Jahrzehnten. Was sich geändert hat, ist die Fähigkeit der Technologie, ihre Versprechen zu erfüllen. KI-Wissensdatenbanken lösen grundlegende Geschäftsprobleme, die es seit Anbeginn des Informationszeitalters gibt.
            </p>

            <h2 className="text-2xl font-medium text-white mt-12 mb-6">Die Zukunft: Wohin sich KI-Wissensdatenbanken entwickeln</h2>
            
            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Der Wissensdatenbank-Markt entwickelt sich schnell weiter, wobei sich mehrere Trends abzeichnen:
            </p>

            <ul className="list-disc pl-6 mb-12 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li><strong>Multimodale Fähigkeiten</strong> - Verarbeitung und Verständnis von Bildern, Diagrammen und Videoinhalten neben Text</li>
              <li><strong>Proaktive Wissensbereitstellung</strong> - KI, die Informationsbedarf anhand des Kontexts vorhersagt und relevantes Wissen bereitstellt, bevor es angefordert wird</li>
              <li><strong>Wissensgraphen</strong> - Visualisierung von Beziehungen zwischen Informationen, um Erkenntnisse aufzudecken, die sonst verborgen bleiben würden</li>
              <li><strong>Personalisierte Wissensbereitstellung</strong> - Anpassung von Informationen basierend auf der Rolle, dem Fachwissen und den bisherigen Interaktionen des Benutzers</li>
              <li><strong>KI-Agenten</strong> - Über die reine Beantwortung von Fragen hinaus zu Systemen, die basierend auf der Wissensdatenbank Aktionen durchführen können</li>
            </ul>

            <p className="mb-12 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Die Grenze zwischen Wissensdatenbanken und intelligenten Assistenten verschwimmt zunehmend, wodurch Systeme entstehen, die nicht nur Dinge wissen, sondern dieses Wissen auch nutzen können, um Aufgaben zu erledigen.
            </p>

            <h2 className="text-2xl font-medium text-white mt-12 mb-6">Häufig gestellte Fragen zu KI-gestützten Wissensdatenbanken</h2>
            
            <h3 className="text-xl font-medium text-white mt-8 mb-4">Wie unterscheidet sich eine KI-Wissensdatenbank von der Nutzung von ChatGPT?</h3>
            <p className="mb-8 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Allgemeine KI wie ChatGPT fehlt der Kontext zu Ihrem spezifischen Unternehmen. Sie hat keinen Zugriff auf Ihre internen Dokumente, Richtlinien oder früheren Entscheidungen. Eine KI-Wissensdatenbank wird mit den Informationen Ihres Unternehmens trainiert und liefert präzise, kontextbezogene Antworten basierend auf Ihren tatsächlichen Daten.
            </p>

            <h3 className="text-xl font-medium text-white mt-8 mb-4">Was passiert, wenn sich Informationen ändern oder aktualisiert werden?</h3>
            <p className="mb-8 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Gute KI-Wissensdatenbank-Systeme synchronisieren sich kontinuierlich mit Ihren Datenquellen, um sicherzustellen, dass sie immer über die neuesten Informationen verfügen. Wenn Dokumente aktualisiert werden, spiegelt die Wissensdatenbank diese Änderungen automatisch wider.
            </p>

            <h3 className="text-xl font-medium text-white mt-8 mb-4">Wie stellen wir sicher, dass die KI genaue Antworten liefert?</h3>
            <p className="mb-8 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Drei Schlüsselfaktoren gewährleisten die Genauigkeit:
            </p>
            <ol className="list-decimal pl-6 mb-8 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li>Verbindung zu umfassenden, aktuellen Informationsquellen</li>
              <li>Verwendung von Abruftechniken, die die Antworten der KI in Ihren tatsächlichen Dokumenten verankern</li>
              <li>Implementierung von Feedback-Mechanismen, mit denen Benutzer falsche Antworten melden können</li>
            </ol>
            <p className="mb-8 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Einige Plattformen bieten auch Workflows zur Überprüfung durch Menschen für sensible Themen an.
            </p>

            <h3 className="text-xl font-medium text-white mt-8 mb-4">Mit welcher Rendite können wir rechnen?</h3>
            <p className="mb-6 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Während die Ergebnisse je nach Unternehmen variieren, gehören zu den typischen Ergebnissen:
            </p>
            <ul className="list-disc pl-6 mb-8 space-y-2 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              <li>20-30 % weniger Zeit für die Suche nach Informationen</li>
              <li>25-40 % schnellere Einarbeitung neuer Mitarbeiter</li>
              <li>30-50 % weniger interne Support-Tickets</li>
              <li>Deutliche Verbesserung der Mitarbeiterzufriedenheit</li>
            </ul>
            <p className="mb-12 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Die meisten Unternehmen verzeichnen innerhalb von 3-6 Monaten nach der Implementierung eine positive Kapitalrendite.
            </p>

            <p className="text-xl mb-12 text-white/70 text-base font-geist tracking-[-0.02em] leading-relaxed">
              Das Wissen in Ihrem Unternehmen repräsentiert Jahre an Erfahrung, unzählige Arbeitsstunden und Investitionen in Millionenhöhe. Eine KI-gestützte Wissensdatenbank stellt sicher, dass dieses intellektuelle Kapital nicht irgendwo in Ihren Systemen schlummert, sondern für jeden Mitarbeiter jeden Tag zugänglich, nutzbar und wertvoll wird.
            </p>

            <div className="border-t border-white/10 my-12 pt-12">
                <h3 className="text-xl font-geist font-medium tracking-[-0.02em] mb-6"><span className="text-white">Bereit zu starten?</span> <span className="text-white/50">Analysiere dein Unternehmen mit unserer kostenlosen <br/>KI-Potentialanalyse oder kontaktiere uns direkt!</span></h3>
                <div className="flex flex-wrap gap-4">
                  <a href="https://audit.blcks.at" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-2.5 bg-white text-gray-900 font-geist font-medium text-sm rounded-full hover:bg-gray-100 transition-colors">
                    Kostenlose KI-Analyse starten
                  </a>
                  <a href="/contact" className="inline-flex items-center justify-center px-6 py-2.5 border border-white/20 text-white font-geist font-medium text-sm rounded-full hover:bg-white/5 transition-colors">
                    Jetzt beraten lassen
                  </a>
                </div>
              </div>


          </div>
        </div>
      </article>

      <FooterWrapper />
    </div>
  );
};

export default KIBasierteWissensdatenbanken;
